export default "__VITE_ASSET__FjrVeeT1__"